import { createContextScope } from '@radix-ui/react-context';

const TEXT_FIELD_NAME = "TextField";
const [createTextFieldContext, createTextFieldScope] = createContextScope(TEXT_FIELD_NAME);
const [TextFieldProvider, useTextFieldContext] = createTextFieldContext(TEXT_FIELD_NAME);

export { TextFieldProvider, createTextFieldScope, useTextFieldContext };
//# sourceMappingURL=context.mjs.map
